import React from 'react';
import MuiDivider, { DividerProps } from '@mui/material/Divider';

export type { DividerProps };

export const Divider: React.FC<DividerProps> = (props) => <MuiDivider {...props} />;
